<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<div class="top-actions">
			<period-dialog :button-text="'Report'" :dialog-button-text="'Export'" @selected="handleExportReport"></period-dialog>
		</div>

		<v-tabs v-model="tab" @change="handleTabChanged">
			<v-tab v-for="(item, index) in options" :key="index">{{ item.text }}</v-tab>
		</v-tabs>

		<v-tabs-items v-model="tab">
			<v-tab-item>
				<v-card flat tile color="grey lighten-3" class="pa-3 pb-5">
			  		<suspend-card 
			  			class="mb-3" 
			  			v-for="(item, index) in listItems.opened.items" 
			  			:key="index" 
			  			:item="item"
			  			@preview="handlePreview"
			  			@approve="handleApprove"
						@delete="handleDelete"
						@restore="handleRestore"
						@send-message="handleSendMessage"
						@unpublish="handleUnpublish">
		  		 	</suspend-card>

					<div class="text-xs-center pagination-wrapper py-2" v-if="listItems.opened.totalRecords">
						<v-pagination v-model="listItems.opened.page" :length="listItems.opened.maxPage" :total-visible="7" @input="handlePageChanged(listItems.opened.page)"></v-pagination>
					</div>

					<v-alert :value="!listItems.opened.items.length" type="info" class="white--text">No more incoming requests.</v-alert>
				</v-card>
			</v-tab-item>
			<v-tab-item>
				<v-card flat tile color="grey lighten-3" class="pa-3 pb-5">
			  		<suspend-card 
			  			class="mb-3" 
			  			v-for="(item, index) in listItems.closed.items" 
			  			:key="index" 
			  			:item="item"
			  			@preview="handlePreview"
			  			@approve="handleApprove"
						@delete="handleDelete"
						@restore="handleRestore"
						@send-message="handleSendMessage"
						@unpublish="handleUnpublish">
		  		 	</suspend-card>

					<div class="text-xs-center pagination-wrapper py-2" v-if="listItems.closed.totalRecords">
						<v-pagination v-model="listItems.closed.page" :length="listItems.closed.maxPage" :total-visible="7" @input="handlePageChanged(listItems.closed.page)"></v-pagination>
					</div>
				</v-card>
			</v-tab-item>
		</v-tabs-items>

		<content-preview  :content-keys="previewKeys" @close="closePreview"></content-preview>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import SuspendCard from '@/views/request/suspending/Card.vue'
	import ContentPreview from '@/components/ContentPreview.vue'
	import PeriodDialog from '@/components/PeriodDialog.vue'
	
	export default {
		components: {
			SuspendCard,
			ContentPreview,
			PeriodDialog
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Request',
						disabled: true,
						href: config.PUBLIC_PATH + 'request'
					},
					{
						text: 'Suspend Management (จัดการกระทู้ Suspend ทั้งหมด)',
						disabled: true,
						href: config.PUBLIC_PATH + 'request/suspending-list'
					}					
				],
				pageSize: 5,
				loading: true,
				previewKeys: null,
				listItems: {
					opened: {
		                page: 1,
						maxPage: 1,
		                totalRecords: 0,
		                items: []
					},
					closed: {
		                page: 1,
						maxPage: 1,
		                totalRecords: 0,
		                items: []
					}
				},
				options: [
					{ value: 'opened', text: 'IN PROCESS'},
					{ value: 'closed', text: 'CLOSED'}
				],
				tab: 0,
				dummyInterval: null
			}
		},
		methods: {
			convertToCSV(objArray) {
			    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
			    var str = '';

			    for (var i = 0; i < array.length; i++) {
			        var line = '';
			        for (var index in array[i]) {
			            if (line != '') line += ','

			            line += '"' + array[i][index] + '"';
			        }

			        str += line + '\r\n';
			    }

			    return str;
			},
			scrollTop ()
			{
			    this.dummyInterval = setInterval(() => {
				    if (window.pageYOffset === 0) {
				        clearInterval(this.dummyInterval)
				    }
				    window.scroll(0, window.pageYOffset - 50)
			    }, 2.5)
			},
			handleTabChanged (tab)
			{
				this.option = this.options[tab].value
				// this.handlePageChanged(1)
				this.handlePageChanged(this.listItems[this.option].page)
			},
			handlePageChanged (page) 
			{
				let url = `${config.BASE_URL}/suspend/${this.option}`
				let params = { page: page, limit: this.pageSize }

				axios.get( url, { params: params })
					.then((response) => {
						if (response.data.code == 0) {
							if (response.data.data.totalRecords > 0) {
								this.listItems[this.option] = {
									page: response.data.data.page,
									maxPage: this.listItems[this.option].maxPage,
									totalRecords: response.data.data.totalRecords,
									items: response.data.data.suspendList
								}
								if (response.data.data.totalRecords == this.pageSize) {
									this.listItems[this.option].maxPage = (this.listItems[this.option].page >= this.listItems[this.option].maxPage) ? (this.listItems[this.option].page + 1) : this.listItems[this.option].maxPage
								} else if (response.data.data.totalRecords > 0) {
									this.listItems[this.option].maxPage = this.listItems[this.option].page
								} else {
									this.listItems[this.option].maxPage = 1
									this.handlePageChanged(page - 1)
								}

								// this.scrollTop()
							}
						}
					})
			},
			closePreview ()
			{
				this.previewKeys = null
			},
			handlePreview (keys) 
			{
				this.previewKeys = keys
			},
			handleSendMessage (params)
			{
				if (!params.message) {
					return
				}

				axios.post(`${config.BASE_URL}/suspend/${params.id}/message`, 
					{
						message: params.message
					})
					.then(response => {
						if (response.data.code === 0) {
							this.handlePageChanged(this.listItems[this.option].page)
							this.closePreview()
						} else {
							console.log(error)
							this.$store.commit(types.SET_ERROR_MSG, response.data.message)
						}
					})
					.catch(error => {
						console.log(error)
						this.$store.commit(types.SET_ERROR_MSG, error)
					})						
			},
			handleApprove (keys) 
			{
				this.$swal({
					title: "APPROVE ?",
					text: "ต้องการยกเลิกการ Suspend คอนเทนท์นี้",
					type: "question",
					showCancelButton: true,
					cancelButtonText: "ยังก่อน",
					confirmButtonText: "โอเค"
				}).then(response => {
					if (response.value) {
						axios.put(`${config.BASE_URL}/suspend/${keys.contentType}/${keys.contentId}`, { statusType: 'approve' })
							.then((response) => {
								if(response.data.code === 0) {
									this.handlePageChanged(this.listItems[this.option].page)
									this.closePreview()
								} else {
									this.$store.commit(types.SET_ERROR_MSG, response.data.message)
								}
							})
					}
				})
			},
			handleDelete (params)
			{
				this.$swal({
					title: "ต้องการลบรายการนี้ ?",
					text: "ลบรายการ Suspend เท่านั้น, คอนเทนท์จะยังไม่กลับเข้าสู่ Community",
					icon: 'warning',
					showCancelButton: true,
					cancelButtonText: 'ยังก่อน',
					confirmButtonText: 'ลบเลยจ้า'
				}).then(response => {
					if (response.value) {
						axios.delete(`${config.BASE_URL}/suspend/${params.id}`)
							.then((response) => {
								if(response.data.code === 0) {
									this.handlePageChanged(this.listItems[this.option].page)
									this.closePreview()
								} else {
									this.$store.commit(types.SET_ERROR_MSG, response.data.message)
								}
							})
							.catch(error => {
								console.log(error)
								this.$store.commit(types.SET_ERROR_MSG, error)
							})
						// axios.delete(`${config.BASE_URL}/suspend/${params.id}`)
						// 	.then(response => {
						// 		if(response.data.code === 0) {
						// 			axios.post(`${config.BASE_URL}/published`, 
						// 				{
						// 					contentType: params.keys.contentType,
						// 					contentId: params.keys.contentId
						// 				})
						// 				.then((response) => {
						// 					if(response.data.code === 0) {
						// 						this.handlePageChanged(this.listItems[this.option].page)
						// 						this.closePreview()
						// 					} else {
						// 						this.$store.commit(types.SET_ERROR_MSG, response.data.message)
						// 					}
						// 				})
						// 				.catch(error => {
						// 					console.log(error)
						// 					this.$store.commit(types.SET_ERROR_MSG, error)
						// 				})						
						// 		} else {
						// 			this.$store.commit(types.SET_ERROR_MSG, response.data.message)
						// 		}
						// 	})
						// 	.catch(error => {
						// 		console.log(error)
						// 		this.$store.commit(types.SET_ERROR_MSG, error)
						// 	})						
					}
				})
			},
			handleRestore (id)
			{
				axios.put(`${config.BASE_URL}/suspend/${id}/recover`, {})
					.then((response) => {
						if(response.data.code === 0) {
							this.handlePageChanged(this.listItems[this.option].page)
							this.closePreview()
						} else {
							this.$store.commit(types.SET_ERROR_MSG, response.data.message)
						}
					})
			},
			handleUnpublish (params)
			{
				this.$swal({
					title: "ต้องการ Unpublish คอนเทนท์นี้ ?",
					text: `[${params.keys.contentType}:${params.keys.contentId}]`,
					icon: 'warning',
					showCancelButton: true,
					cancelButtonText: 'เก็บไว้ก่อน',
					confirmButtonText: 'สอยเลยจ้า'
				}).then(response => {
					if (response.value) {
						axios.delete(`${config.BASE_URL}/${params.keys.contentType.toLowerCase()}/${params.keys.contentId}/publish`)
							.then(response => {
								if(response.data.code === 0) {
									axios.delete(`${config.BASE_URL}/suspend/${params.id}`)
										.then((response) => {
											if(response.data.code === 0) {
												this.handlePageChanged(this.listItems[this.option].page)
												this.closePreview()
											} else {
												this.$store.commit(types.SET_ERROR_MSG, response.data.message)
											}
										})
										.catch(error => {
											console.log(error)
											this.$store.commit(types.SET_ERROR_MSG, error)
										})
								} else {
									this.$store.commit(types.SET_ERROR_MSG, response.data.message)
								}
							})
							.catch(error => {
								console.log(error)
								this.$store.commit(types.SET_ERROR_MSG, error)
							})						
					}
				})
			},
			handleExportReport (period)
			{
				axios.get(`${config.BASE_URL}/suspend/log`, { params: 
					{
						startDate: period.startDate,
						endDate: period.endDate
					}
				})
					.then(response => {
		        		var csv = response.data
		        		var exportedFilename = `content-suspend-log-${period.startDate.replaceAll('-', '')}-to-${period.endDate.replaceAll('-', '')}.csv`

		        		if (csv.hasOwnProperty('httpStatusCode') && csv.httpStatusCode != 200) {
		        			alert(csv.message)
		        			return
		        		}

					    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
					    if (navigator.msSaveBlob) { // IE 10+
					        navigator.msSaveBlob(blob, exportedFilename)
					    } else {
					        var link = document.createElement("a")
					        if (link.download !== undefined) { // feature detection
					            // Browsers that support HTML5 download attribute
					            var url = URL.createObjectURL(blob)
					            link.setAttribute("href", url)
					            link.setAttribute("download", exportedFilename)
					            link.style.visibility = 'hidden'
					            document.body.appendChild(link)
					            link.click()
					            document.body.removeChild(link)
					        }
					    }
	        		})
			}
		},
		mounted () {
			this.handleTabChanged(0)
		}
	}
</script>

<style lang="scss">
	.pagination-wrapper {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		background: rgba(255, 255, 255, .8);
		box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)
	}

	.top-actions {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-bottom: 15px;
	}
</style>